import { render, staticRenderFns } from "./searchHolderDependentDelete.vue?vue&type=template&id=4c15dec6&"
import script from "./searchHolderDependentDelete.vue?vue&type=script&lang=js&"
export * from "./searchHolderDependentDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports